// labelHelpers.ts

// Define a set of words that should always be uppercase
const UPPERCASE_EXCEPTIONS = new Set(['UI', 'BG', 'MS', '2D', '3D', 'HP']);

/**
 * Converts an UPPER_SNAKE_CASE string to Title Case With Spaces,
 * with exceptions for certain words that should remain uppercase.
 * @param {string} constantName The constant name in UPPER_SNAKE_CASE.
 * @returns {string} The formatted label.
 */
export const formatConstantNameToLabel = (constantName: string): string => {
    return constantName
        .split('_')
        .map(word => UPPERCASE_EXCEPTIONS.has(word) ? word : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};

/**
 * Converts a Title Case With Spaces label back to UPPER_CASE_WITH_UNDERSCORES.
 * @param {string} label The label in Title Case With Spaces.
 * @returns {string} The constant name in UPPER_CASE_WITH_UNDERSCORES.
 */
export const formatLabelToConstantName = (label: string): string => {
    return label
        .split(' ')
        .map(word => word.toUpperCase())
        .join('_');
};